import axios from 'axios';
import { API_BASE } from './config';

interface JoinResponse {
  playerId: string;
  roomCode: string;
  token: string;
  isHost: boolean;
  sanitizedName?: string;
}

export async function createRoomApi(): Promise<{ roomCode: string }> {
  const response = await axios.post(`${API_BASE}/api/create-room`);
  return response.data;
}

export async function joinRoomApi(roomCode: string, playerName: string): Promise<JoinResponse> {
  const response = await axios.post(`${API_BASE}/api/join-room`, {
    roomCode: roomCode.trim(),
    playerName: playerName.trim(),
  });
  return response.data;
}

export async function uploadPhotoApi(
  file: File,
  roomCode: string,
  playerId: string,
  onProgress: (percent: number) => void,
  photoIndex = 0,
  totalPhotos = 1,
): Promise<void> {
  const formData = new FormData();
  formData.append('photo', file);
  formData.append('roomCode', roomCode);
  formData.append('playerId', playerId);

  await axios.post(`${API_BASE}/api/upload-photo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (progressEvent) => {
      if (totalPhotos > 1) {
        const currentPhotoProgress = progressEvent.total
          ? progressEvent.loaded / progressEvent.total
          : 0;
        const totalProgress = ((photoIndex + currentPhotoProgress) / totalPhotos) * 100;
        onProgress(Math.round(totalProgress));
      } else {
        const percent = progressEvent.total
          ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
          : 0;
        onProgress(percent);
      }
    },
  });
}

export async function startGameApi(roomCode: string, playerId: string): Promise<void> {
  await axios.post(`${API_BASE}/api/start-game`, { roomCode, playerId });
}

export async function submitGuessApi(
  roomCode: string,
  playerId: string,
  guessedPlayerId: string,
  timeToAnswer: number,
): Promise<void> {
  await axios.post(`${API_BASE}/api/submit-guess`, {
    roomCode,
    playerId,
    guessedPlayerId,
    timeToAnswer,
  });
}

export async function resetGameApi(roomCode: string, playerId: string): Promise<void> {
  await axios.post(`${API_BASE}/api/reset-game`, { roomCode, playerId });
}
